import React from 'react';

const DetailsDesktop = (props) => 
<div>
    <h1>Details Desktop</h1>
</div>

export default DetailsDesktop;


// WEBPACK FOOTER //
// ./components/Details/DetailsDesktop.js